import React, { useState, useEffect, useRef } from "react";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import CustomHorizontalBarChart from "../CustomComponents/CustomHorizontalBarChart/CustomHorizontalBarChart";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { useStyles } from "../../assets/jss/Events";
import clsx from "clsx";
import {
  getEventType,
  getUserData,
  getSession,
  getUserRBAC,
  isShowEventDetails,
  setDistractionEventIndex,
  getDistractionEventIndex,
  getIsCameFromEventDetailsPage,
  setIsCameFromEventDetailsPage
} from "../../services/LocalStorageService";
import trackEvents from "../../assets/appInsightsEvents";
import { EventCode, RBAC_CODE, TableComponentCodes } from "../../config/app-globals.enum";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { getEventsSummary } from "../../services/EventsSummary";
import { useTranslation } from "react-i18next";
import PraisoTableWrapper from "../../components/CustomComponents/PraisoTable/PraisoTableWrapper";
import { useParams } from "react-router-dom";

export default function DistractionTab(props) {
  const params = useParams();

  const { t } = useTranslation();
  const classes = useStyles();
  const [getRBAC_UserDetailView] = React.useState(
    getUserRBAC(RBAC_CODE.USER_DETAIL_VIEW, props)
  );
  const [userSession] = useState(getSession);
  const [pageLength, setPageLength] = useState(null);
  const [pageLengthArray, setPageLengthArray] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(null);
  const [userData] = React.useState(getUserData);
  const [eventTypes] = React.useState(getEventType);
  const [isVisibleEventDtls] = React.useState(isShowEventDetails(EventCode.CORNERING));
  const [defaultFilterBy, setDefaultFilterBy] = React.useState({
    eventTypeId: null,
  });
  const [distractionEvent, setDistractionEvent] = React.useState(null);
  const [distractionChildEvents, setDistractionChildEvents] = React.useState(null);
  const [distractionChildEventCount, setDistractionChildEventCount] =
    React.useState(null);
  const [DistractionChildEventsLabel, setDistractionChildEventslabel] =
    React.useState(null);
  const [userList, setUserList] = React.useState([]);
  const [graphData, setGraphData] = useState({
    data: {
      labels: [],
      datasets: [],
    },
    distractionReport: {},
    selectedBar: 0,
    loading: false,
  });
  const [isApiFailed, setIsApiFailed] = useState(false);
  const [tableApiFailed] = useState(false);

  const [distractionData, setDistractionData] = useState({
    loading: true,
    currentData: [],
  });
  const [isApi, setIsApi] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setPage(0);
  }, [graphData.selectedBar]);

  useEffect(() => {
    if (userSession) {
      setPageLength(userSession.pageLength);
    }
  }, [userSession]);

  useEffect(() => {
    if (pageLength) {
      const pageArray = [10, 100, 500];
      setRowsPerPage(10);
      setPageLengthArray(pageArray);
    }
  }, [pageLength]);

  //====
  const [statusValue, setStatusValue] = React.useState();
  const [alertMessage, setAlertMessage] = React.useState("");
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);
  const changeApiStatusCodeFunc = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setStatusValue(status.code);
      setAlertMessage(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen(true);
    }
  };
  //====
  useEffect(() => {
    if (eventTypes && eventTypes.length > 0) {
      const distractionEventObj = eventTypes.find(
        (event) => event.code === "DISTRACTION"
      );
      setDistractionEvent(distractionEventObj);
    }
  }, [eventTypes]);
  //====
  //====
  useEffect(() => {
    if (distractionEvent) {
      const distractionChildEventsArray = eventTypes.filter(
        (event) => event.parentEventTypeId === distractionEvent.id
      );
      setDistractionChildEvents(distractionChildEventsArray);
    }
  }, [distractionEvent]);
  //====
  useEffect(() => {
    if (distractionChildEvents && distractionChildEvents.length > 0) {
      const labels = [];
      for (const event of distractionChildEvents) {
        labels.push(event.name);
      }
      setDistractionChildEventslabel(labels);
    }
  }, [distractionChildEvents]);
  //====
  //====
  const [eventStatus, setEventStatus] = useState(false);

  const mounted = useRef(false);
  useEffect(()=>{
    mounted.current = true;
    if (getIsCameFromEventDetailsPage() !== undefined && getIsCameFromEventDetailsPage() !== null && getIsCameFromEventDetailsPage() === 0) {
      setDistractionEventIndex(-1);
    }
    return () => {
      mounted.current = false;
      if (getIsCameFromEventDetailsPage() !== undefined && getIsCameFromEventDetailsPage() !== null && getIsCameFromEventDetailsPage() === 1) {
          setIsCameFromEventDetailsPage(0);
      }
  };
  },[]);

  async function loadData() {
    let selectedBarIndex = 0;
    if (getDistractionEventIndex() !== undefined && getDistractionEventIndex() !== null && getDistractionEventIndex() !== -1) {
      selectedBarIndex = getDistractionEventIndex();
    }
    setStatusValue(null);
    setAlertMessage("");
    setIsApi(true);
    setIsAlertOpen(false);
    const data = await getEventsSummary({ eventTypeId: distractionEvent.id }, params);
    if (
      data &&
      (data.status.code === 0 ||
        data.status.code === 200 ||
        data.status.code === 201) &&
      data.content
    ) {
      data.content.eventStatus === 1 ? setEventStatus(true) : setEventStatus(false);
      setIsApi(false);
      const eventCount = [];
      for (const event of distractionChildEvents) {
        const eventItem = data.content.eventCounts.find(
          (item) => item.eventTypeId === event.id
        );
        if (eventItem) {
          eventCount.push(eventItem.eventCount);
        } else {
          eventCount.push(0);
        }
      }
      const filteredByEventId = data.content.eventDetails.filter(
        (item) => item.eventTypeId === distractionChildEvents[selectedBarIndex].id
      );
      setDistractionChildEventCount(eventCount);
      setDefaultFilterBy({
        ...defaultFilterBy,
        eventTypeId: distractionChildEvents[selectedBarIndex].id,
      });
      setUserList(data.content.eventDetails);
      setDistractionData({
        ...distractionData,
        currentData: filteredByEventId,
        loading: false,
      });
      setGraphData({
        ...graphData,
        distractionReport: data.content,
        selectedBar:selectedBarIndex
      });
    } else {
      setIsApi(true);
      setIsApiFailed(true);
      const staticGraph = {
        ExcessSpeedCount: 198,
        FastApproachCount: 0,
        PoorTechniqueCount: 8,
        ApiRootPath: "/api/",
        StartDate: "2020-10-16T01:03:18.0163567+01:00",
        EndDate: "2020-11-06T01:03:18.0163567+00:00",
        MaxEventsPerPage: 100,
        TelematicsProvider: 0,
      };
      setGraphData({
        ...graphData,
        loading: false,
        distractionReport: staticGraph,
      });
      changeApiStatusCodeFunc(data.status);
    }
  }
  useEffect(() => {
    if (distractionChildEvents && graphData) {
      loadData();
    }
  }, [distractionChildEvents]);

  useEffect(() => {
    if (
      graphData.selectedBar !== null &&
      graphData.selectedBar !== undefined &&
      distractionChildEvents

    ) {
      setDefaultFilterBy({
        ...defaultFilterBy,
        eventTypeId: distractionChildEvents[graphData.selectedBar].id,
      });
      setDistractionData({
        ...distractionData,
        currentData: [],
        loading: false,
      });
    }
  }, [graphData.selectedBar]);

  useEffect(() => {
    if (
      graphData.distractionReport &&
      graphData.selectedBar !== null &&
      graphData.selectedBar !== undefined &&
      distractionChildEventCount
    ) {
      const bgColor = distractionChildEventCount.map((dt, index) => {
        let color =
          graphData.selectedBar === index
            ? isApiFailed
              ? "rgb(241, 242, 246)"
              : "rgba(46, 91, 255, 1)"
            : isApiFailed
              ? "rgb(241, 242, 246)"
              : "rgba(46, 91, 255, 0.3)";
        return color;
      });
      setGraphData({
        ...graphData,
        data: {
          labels: DistractionChildEventsLabel,
          datasets: [
            {
              label: t("MOBILE_DISTRACTION"),
              barPercentage: 0.5,
              barThickness: 20,
              borderWidth: isApiFailed ? 0 : 1,
              maxBarThickness: 20,
              minBarLength: 2,
              data: distractionChildEventCount,
              backgroundColor: bgColor,
            },
          ],
        },
      });
    }
  }, [graphData.distractionReport, graphData.selectedBar]);

  //====
  const [statusValue1, setStatusValue1] = React.useState();
  const [alertMessage1, setAlertMessage1] = React.useState("");
  const [isAlertOpen1, setIsAlertOpen1] = React.useState(false);
  const changeApiStatusCodeFunc1 = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setStatusValue1(status.code);
      setAlertMessage1(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen1(true);
    }
  };

  //Filter API reponse for Event type
  const [filteredTableData, setFilteredTableData] = useState(null);
  useEffect(() => {
    let filteredData = [];
    for (let i = 0; i < userList.length; i++) {

      if (userList[i].eventTypeId === defaultFilterBy.eventTypeId) {
        filteredData.push(userList[i]);
      }
    }
    setFilteredTableData(filteredData);
  }, [defaultFilterBy, userList]);

  return (
    <>
      <CustomGrid container spacing={4} justifyContent="space-between">
        <CustomGrid item xs={12}>
          <CustomPaper square elevation={0}>
            {isApi ? (
              <CustomCard
                elevation={0}
                className={clsx(
                  classes.cardContentWrapper,
                  classes.cardContentWrapperCenter
                )}
              >
                {isApi && (
                  <CustomPaper
                    className={classes.loadingContainer}
                    elevation={0}
                  >
                    <CustomCircularProgress />
                  </CustomPaper>
                )}
              </CustomCard>
            ) : null}
            {!isApi ? (
              <CustomCard
                elevation={0}
                className={clsx(
                  classes.cardContentWrapper,
                  isApiFailed ? classes.graphDisabled : null
                )}
              >
                {Object.keys(graphData.distractionReport).length === 0 && (
                  <CustomPaper className={classes.loadingContainer} elevation={0}>
                    <CustomCircularProgress />
                  </CustomPaper>
                )}
                {Object.keys(graphData.distractionReport).length !== 0 && (
                  <CustomCardContent
                    className={clsx(
                      classes.cardContent,
                      isApiFailed ? classes.cardContentDisabled : null
                    )}
                    style={{ padding: "1.5em 3em" }}
                  >
                    <CustomGrid container>
                      <CustomGrid item xs={12}>
                        <CustomHorizontalBarChart
                          className={classes.reportGraph}
                          data={graphData.data}
                          options={{
                            legend: { display: false },
                            scales: {
                              xAxes: [
                                {
                                  ticks: { beginAtZero: true },
                                  gridLines: { display: false },
                                },
                              ],
                              yAxes: [
                                {
                                  ticks: { beginAtZero: true },
                                  gridLines: { display: false },
                                },
                              ],
                            },
                            onClick: (e, item) => {
                              if (item.length !== 0) {
                                trackEvents("Event", {
                                  name: "Distraction",
                                  value: graphData.data.labels[item[0]["_index"]],
                                }, params);
                              }
                              item &&
                                item[0] &&
                                setGraphData({
                                  ...graphData,
                                  selectedBar: item[0]["_index"],
                                });
                                setDistractionEventIndex(item[0]["_index"]);
                            },
                          }}
                          height={70}
                        />
                      </CustomGrid>
                    </CustomGrid>
                  </CustomCardContent>
                )}
              </CustomCard>
            ) : null}
          </CustomPaper>
        </CustomGrid>
      </CustomGrid>
      <CustomGrid container spacing={4} justifyContent="space-between">
        <CustomGrid item xs={12} className={classes.cardContentWrapper}>
          {distractionEvent && !isApi && isVisibleEventDtls ? (
            <PraisoTableWrapper
              // getTableSettingAPI="/tableSettingApi"              
              //tableSettingView="distractionEventUserList"
              // getTableSettingAPI="user-table-component-mapping?tcId=11"
              // tableSettingView="deul"
              getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.MOBILE_DISTRACTION}`}
              tableSettingView={TableComponentCodes.MOBILE_DISTRACTION}
              preFetchedTableData={filteredTableData}
              callBackFun={loadData}
              {...props}
            />
          ) : null}
        </CustomGrid>
      </CustomGrid>
      <ErrorAlert
        code={statusValue}
        message={alertMessage}
        isOpen={isAlertOpen}
        isClose={(isClose) => setIsAlertOpen(!isClose)}
      />
      <ErrorAlert
        code={statusValue1}
        message={alertMessage1}
        isOpen={isAlertOpen1}
        isClose={(isClose) => setIsAlertOpen1(!isClose)}
      />
    </>
  );
}
